export const queryKeys = {
  documents: (resourceId: string) => ['documents', resourceId] as const,
  folderFiles: (type: 'estate' | 'project', resourceId: string) =>
    ['resource-root-files', type, resourceId] as const,
  archives: (type: 'estate' | 'project', resourceId: string) =>
    ['archives', type, resourceId] as const,
};
